import {AxiosResponse} from 'axios';
import {alert} from 'devextreme/ui/dialog';
import {saveAs} from 'file-saver';

import {BaseEntity} from './base_types';
import request from '@/utils/request';


// @ts-ignore
const openAttachmentByBrowser = config.ATTACHMENTS_OPENS_BY_BROWSER;
export const downloadUrlBase = 'file';
export const maxFileSizeMb = 50;
export const maxNewAttachmentCountPerTime = 5;

// Прежде привязанный файл
export class Attachment extends BaseEntity {
  original_filename: string = '';
  download_path: string = '';
  mimetype?: string;
}

export class AttachmentToUploadPresentation {
  name: string = '';
  pict: string = '';
}

// Только что привязанный и ещё не загруженный на сервер файл
export class AttachmentToUpload {
  name: string = '';
  type: string = '';
  content: string | null = null;
}

// Предок для Equipment и Company
export class EntityWithAttachments extends BaseEntity {
  attachments?: Attachment[]; // Прежде привязанные файлы
  new_attachments?: AttachmentToUpload[] = []; // Только что привязанные и ещё не загруженные на сервер файлы
}

// Предок для Equipment и Company
export class CompanyEntityWithAttachments extends BaseEntity {
  documents?: Attachment[]; // Прежде привязанные файлы
  new_documents?: AttachmentToUpload[] = []; // Только что привязанные и ещё не загруженные на сервер файлы
  correspondence?: Attachment[]; // Прежде привязанные файлы
  new_correspondence?: AttachmentToUpload[] = []; // Только что привязанные и ещё не загруженные на сервер файлы
}

export function onFileValidated(result: string | boolean, files: FileList, extensions: string, maxSize: number): void {
  if (files.length < 1 || result === true) {
    return;
  }
  if (result === false) {
    alert('При выборе файла ' + files[0].name + ' произошла неизвестная ошибка', 'Ошибка');
    return;
  }
  if (result === 'EXTENSION_ERROR') {
    alert('Имя файла ' + files[0].name + ' имеет недопустимое расширение.<br>' +
      'Допустимы расширения ' + extensions, 'Ошибка');
  } else if (result === 'FILE_SIZE_ERROR') {
    alert('Файл ' + files[0].name + ' слишком велик.<br>' +
      'Максимальный допустимый размер ' + maxSize.toString(10) + ' Mб', 'Ошибка');
  } else if (result === 'MULTIFILES_ERROR') {
    alert('Допускается выбор только одного файла', 'Ошибка');
  }
}

export function storeFileFromDisk(file: File, emitStart: Function, emitFinish: Function): void {
  const reader = new FileReader();
  reader.onloadend = () => {
    if (reader.readyState < 2) {
      return;
    }
    if (reader.result === null) {
      alert('Ошибка чтения файла ' + file.name, 'Ошибка');
      emitFinish(null);
    } else if (typeof reader.result === 'string') {
      emitFinish({
        name: file.name,
        type: file.type,
        content: reader.result.substr(reader.result.indexOf(',') + 1)
      });
    }
  };

  emitStart();
  reader.readAsDataURL(file);
}

export function downloadAndSaveAttachment(attachment: Attachment): void {
  // @ts-ignore
  const url = `${downloadUrlBase}/${attachment.id}`;
  request({
    url,
    method: 'get',
    responseType: 'blob',
    timeout: 60000
  })
    .then((response: AxiosResponse['data']) => {
      const fileAsObjectURL = URL.createObjectURL(response);
      const fileMayBeOpenedInBrowser = !!attachment.mimetype &&
                                       !!attachment.mimetype.match(/(^application\/pdf$)|(^image\/)/);
      if (openAttachmentByBrowser && fileMayBeOpenedInBrowser) {
        // Дадим браузеру самостоятельно открыть некоторые типы файлов
        const newWindow = window.open();
        if (newWindow) {
          setTimeout(() => { if (newWindow) newWindow.location.assign(fileAsObjectURL); }, 100);
        }
      } else {
        // Firefox предоставляет удобный выбор: открыть файл внешней программой или сохранить.
        // Для других браузеров файлы, которые не откроет сам браузер, можно только сохранить.
        saveAs(fileAsObjectURL, attachment.original_filename);
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

export function downloadPdfDocument(url: string, original_filename: string): void {
  request({
    url,
    method: 'get',
    responseType: 'blob',
    timeout: 60000
  })
    .then((response: AxiosResponse['data']) => {
      const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' });
      const fileAsObjectURL = URL.createObjectURL(blob);
      saveAs(fileAsObjectURL, original_filename);
    })
    .catch((error) => {
      console.error(error);
    });
}


const fileTypePict: {[ext: string]: string} = {
  doc: 'doc.png',
  docx: 'doc.png',
  jpg: 'jpg.png',
  pdf: 'pdf.png',
  png: 'png.png',
  ppt: 'ppt.png',
  pptx: 'ppt.png',
  rtf: 'rtf.png',
  txt: 'txt.png',
  xls: 'xls.png',
  xlsx: 'xls.png',
  zip: 'zip.png',
  bz2: 'zip.png',
  gz: 'zip.png'
};

export function getPictByExtension(filenameExtension: string): string {
  return fileTypePict[filenameExtension] || 'file.png';
}
